bq.paymentCreditcards = function (element, options) {
    this.options = options;
    this.$element = $(element);
    this.$hiddenInput = $('#' + this.options.bqCvvTokenizedInputId);
    this.$rowContainer = false;
};

bq.paymentCreditcards.DEFAULTS = {};

bq.paymentCreditcards.prototype = {
    init: function () {
        this.$rowContainer = this.$element.closest('.row-payment-creditcards');
        this.$element.on('click', this._selectCard.bind(this));
        this.$element.on('bq.paymentCreditcards.selected', this._selectCard.bind(this));
        this._initFirstClick();
    },

    _initFirstClick: function() {
        if (this.$element.is(':checked')) {
            var self = this;
            jQuery(document).ready(function() {
                self.$element.trigger('click');
            });
        }
    },

    getHiddenInput: function() {
        return this.$hiddenInput;
    },

    _selectCard: function(e) {
        // clear previous tokenization artifacts as we need to create a new one that did not expire
        this.getHiddenInput().val(null);
        this.$rowContainer.find('.payment-creditcards-cvv-iframe').html('');
        this.$rowContainer.find('.fa.fa-spinner.fa-spin').css('display', 'inline-block');
        var tokenizerKey = this.options.tokenizer || '';
        var tokenizerContainer = this.$element.parent().find('[data-bq="tokenizer-' + tokenizerKey + '"]');
        if (tokenizerContainer) {
            var $spinner = this.$rowContainer.find('.fa.fa-spinner.fa-spin');
            tokenizerContainer.trigger('bq.tokenizer.createIframe', function () {
                $spinner.css('display', 'none');
            });
        }
    },
};

$.fn.paymentCreditcards = function (option) {
    return this.each(function () {
        var $this = $(this);
        var data = $this.data('bq.paymentCreditcards');
        if (!data) {
            var options = $.extend({}, bq.paymentCreditcards.DEFAULTS, $this.data(), typeof (option) === 'object' && option);
            $this.data('bq.paymentCreditcards', (data = new bq.paymentCreditcards(this, options)));
        }
        data.init();
    });
};

$.fn.paymentCreditcards.Constructor = bq.paymentCreditcards;

bq.paymentCreditcardsInit = function () {
    $('[data-bq="payment-creditcards"]').each(function () {
        var $el = $(this);
        if ($el.data('bq.paymentCreditcards')) {
            return;
        }
        $el.paymentCreditcards($el.data());
    });
};

bq.init.push(bq.paymentCreditcardsInit);
